import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { TopicAreaCardComponent } from '../topic-area-card/topic-area-card.component';
import { ProductDataService } from '../../services/product-data.service';

@Component({
  selector: 'app-topic-area-select',
  imports: [TopicAreaCardComponent],
  templateUrl: './topic-area-select.component.html',
})
export class TopicAreaSelectComponent {
  protected readonly productDataService = inject(ProductDataService);

  @Input() trialing = false;
  @Input() disabled = false;
  @Input() preselected = false;
  @Input() selectedTopicAreaIds: string[] = [];
  @Output() selectedTopicAreaIdsChanged: EventEmitter<string[]> =
    new EventEmitter<string[]>();

  onCardSelect(id: string): void {
    const index = this.selectedTopicAreaIds.indexOf(id);
    if (index > -1) {
      if (this.selectedTopicAreaIds.length > 1) {
        this.onUnselect(index);
      }
    } else {
      this.onSelect(id);
    }
  }

  onUnselect(index: number) {
    this.selectedTopicAreaIds.splice(index, 1);
    this.selectedTopicAreaIdsChanged.emit([...this.selectedTopicAreaIds]);
  }

  onSelect(id: string) {
    this.selectedTopicAreaIds.push(id);
    this.selectedTopicAreaIdsChanged.emit([...this.selectedTopicAreaIds]);
  }

  isCardSelected(id: string): boolean {
    if (this.preselected) {
      return false;
    }
    return this.selectedTopicAreaIds.includes(id);
  }

  isCardTrialing(id: string): boolean {
    if (this.preselected || !this.trialing) {
      return false;
    }
    return this.productDataService.trialingTopicAreaIds().includes(id);
  }
}
